<template>
    <Card>
        <div slot="title">
            <div style="display: flex; align-items: center;">
                充值模板
                <div style="display: flex; align-items: center;margin-left: 20px;">
                    <Select placeholder="请选择渠道" v-model="searchForm.templateChannel" style="margin-left: 20px;">
                        <Option :value="0">IOS</Option>
                        <Option :value="1">Android</Option>
                    </Select>
                    <Input v-model="searchForm.templateName" :maxLength="100" placeholder="请输入模板名称"
                        style="margin-left: 20px;" />

                    <Button @click="handleGetData()" type="primary" style="margin-left: 20px;">查询</Button>
                    <Button @click="searchForm = {}" style="margin-left: 10px;">重置</Button>
                </div>
            </div>

        </div>
        <div slot="extra">
            <div style="display:flex;align-items: center;">
                <Button type="primary" @click="handleOpenEditModal()">
                    新增
                </Button>
            </div>
        </div>
        <div style="display: flex; flex-wrap: wrap;">
            <div v-for="(item, index) in data" :key="index" style="flex: 0 30%;padding: 20px;">
                <Card>
                    <div slot="title">
                        <div style="font-weight: bold;max-width: 70%;">{{ item.templateName }}</div>
                        <div style="font-weight: bold;margin-top: 20px">平台：{{ ['IOS', 'Android'][item.templateChannel]
                        }}
                        </div>
                        <div style="margin-top: 20px">状态：<i-switch :value="item.status"
                                :before-change="() => handleChangeStatus(item)"></i-switch></div>
                    </div>
                    <div slot="extra">
                        <Button type="primary" style="margin-right: 20px;"
                            @click="handleOpenEditModal(item)">编辑</Button>
                        <Poptip confirm title="确定要删除吗？" transfer @on-ok="handleDel(item)">
                            <icon type="ios-trash" :size="20" style="cursor:pointer"></icon>
                        </Poptip>
                    </div>
                    <div class="card-body">
                        <div v-for="(i, j) in [...item.passList, ...item.vipList, ...item.coinList]" :key="j">
                            <div @click="handleOpenModal(i, item)" style="position: relative">
                                <div v-if="i.goodsFirstCharge"
                                    style="position: absolute;right: 0;top: 0;padding: 0px 10px;border-bottom-left-radius: 8px;background: #eee;color:#777">
                                    首充
                                </div>
                                {{ i.goodName }}
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
        <Pages :page="page" :func="handleGetData" :pArr="[3]" />


        <Modal v-model="editVisible" :title="(form.id ? '编辑' : '新增') + '模板'" :width="1000">
            <Form @submit.native.prevent :label-width="100" :model="form" ref="formRef" v-if="editVisible">
                <Row :gutter="24">
                    <Col :span="12">
                    <FormItem label="模板名称：" prop="templateName" :rules="[{ required: true, message: '请输入模板名称' }]">
                        <Input :maxlength="100" v-model="form.templateName" />
                    </FormItem>
                    </Col>
                    <Col :span="12">
                    <FormItem label="平台：" prop="templateChannel" :rules="[{ required: true, message: '请选择' }]">
                        <Select placeholder="请选择平台" v-model="form.templateChannel" @on-change="hanldeGetGoods()">
                            <Option :value="0">IOS</Option>
                            <Option :value="1">Android</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col :span="12">
                    <FormItem label="模板类型：" prop="templateType" :rules="[{ required: true, message: '请选择' }]">
                        <Select placeholder="请选择模板类型" v-model="form.templateType" @on-change="form.vipIdList = [null];form.passIdList = [null]">
                            <Option value="2">通行证</Option>
                            <Option value="1">订阅</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <!-- <Col :span="12">
                    <FormItem label="模板状态：" prop="templateChannel" :rules="[{ required: true, message: '请选择' }]">
                        <i-switch v-model="form.status"></i-switch>
                    </FormItem>
                    </Col> -->
                </Row>
                <!-- <FormItem label="状态：" prop="status" :rules="[{ required: true, message: '请选择' }]">
                    <i-switch v-model="form.status"></i-switch>
                </FormItem> -->
                <Row :gutter="24">
                    <Col :span="12">
                    <div v-if="form.templateType == 1">
                        <FormItem :label-width="0" prop="vipIdList[0]" :rules="[{ required: true, message: '请选择' }]">
                            <Select placeholder="请选择vip付费项" v-model="form.vipIdList[0]" class="vip"
                                :disabled="!form.templateChannel && form.templateChannel != 0">
                                <Option v-for="(item, index) in goodsVipList" :key="index" :value="item.id"
                                    :disabled="form.vipIdList.includes(item.id)">
                                        {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{ item.goodsName }})
                                    </Option>
                            </Select>
                        </FormItem>
                        <div v-for="(i, j) in form.vipIdList" :key="j" v-show="j != 0">
                            <FormItem :label-width="0" :prop="`vipIdList[${j}]`">
                                <div style="display: flex;align-items:center">
                                    <Select placeholder="请选择vip付费项" v-model="form.vipIdList[j]" style="margin-right: 10px;"  class="vip"
                                        :disabled="!form.templateChannel && form.templateChannel != 0">
                                        <Option v-for="(item, index) in goodsVipList" :key="index" :value="item.id"
                                            :disabled="form.vipIdList.includes(item.id)">
                                                {{ item.goodsChannelName }}-{{ item.goodsPrice }}({{ item.goodsName }})
                                            </Option>
                                    </Select>
                                    <icon type="ios-trash" style="cursor: pointer;color:red" :size="20"
                                        @click="form.vipIdList.splice(j, 1)" />
                                </div>
                            </FormItem>
                        </div>
                        <Button v-if="form.vipIdList.length<3" type="primary" style="width: 100%" @click="form.vipIdList.push(null)">
                            <icon type="md-add" />添加vip付费项
                        </Button>
                    </div>
                    <div v-if="form.templateType == 2">
                        <FormItem :label-width="0" prop="passIdList[0]" :rules="[{ required: true, message: '请选择' }]">
                            <Select placeholder="请选择通行证" v-model="form.passIdList[0]" class="vip"
                                :disabled="!form.templateChannel && form.templateChannel != 0">
                                <Option v-for="(item, index) in goodsPassList" :key="index" :value="item.id"
                                    :disabled="form.passIdList.includes(item.id)">
                                    {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{ item.goodsNum }}({{ item.goodsName }})
                                    </Option>
                            </Select>
                        </FormItem>
                        <div v-for="(i, j) in form.passIdList" :key="j" v-show="j != 0">
                            <FormItem  :label-width="0" :prop="`passIdList[${j}]`">
                                <div style="display: flex;align-items:center">
                                    <Select placeholder="请选择通行证" v-model="form.passIdList[j]" style="margin-right: 10px;"  class="vip"
                                        :disabled="!form.templateChannel && form.templateChannel != 0">
                                        <Option v-for="(item, index) in goodsPassList" :key="index" :value="item.id"
                                            :disabled="form.passIdList.includes(item.id)">
                                            
                                                {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{ item.goodsNum }}({{ item.goodsName }})
                                            </Option>
                                    </Select>
                                    <icon type="ios-trash" style="cursor: pointer;color:red" :size="20"
                                        @click="form.passIdList.splice(j, 1)" />
                                </div>
                            </FormItem>
                        </div>
                        <Button v-if="form.passIdList.length<3" type="primary" style="width: 100%" @click="form.passIdList.push(null)">
                            <icon type="md-add" />添加通行证
                        </Button>
                    </div>
                    </Col>

                    <Col :span="12">
                    <Row :gutter="12">
                        <Col :span="12">
                        <FormItem prop="coinItemList[0]" :rules="[{ required: true,  validator:(rule,value,c)=>{if(!form.coinItemList[0]) c('请选择'); else c()} }]" :label-width="0">
                            <button
                                :style="{ width: '100%', height: '50px', border: '1px solid #eee', cursor: !(!form.templateChannel && form.templateChannel != 0) ? 'pointer' : '' }"
                                :disabled="!form.templateChannel && form.templateChannel != 0" @click="(e) => {
                                    e.preventDefault()
                                    handleOpenModal1(form.coinItemList[0],0)
                                }">{{
                                    form.coinItemList[0]?form.coinItemList[0].goodsName : '请选择付费项1'
                                }}</button>
                        </FormItem>

                        </Col>
                        <Col :span="12">
                        <FormItem prop="coinItemList[1]" :rules="[{ required: true,  validator:(rule,value,c)=>{if(!form.coinItemList[1]) c('请选择'); else c()} }]" :label-width="0">
                            <button
                                :style="{ width: '100%', height: '50px', border: '1px solid #eee', cursor: !(!form.templateChannel && form.templateChannel != 0) ? 'pointer' : '' }"
                                :disabled="!form.templateChannel && form.templateChannel != 0" @click="(e) => {
                                    e.preventDefault()
                                    handleOpenModal1(form.coinItemList[1],1)
                                }">{{
                                    form.coinItemList[1]?form.coinItemList[1].goodsName : '请选择付费项2'
                                }}</button>
                        </FormItem>

                        </Col>
                        <Col :span="12">
                        <FormItem prop="coinItemList[2]" :rules="[{ required: true,  validator:(rule,value,c)=>{if(!form.coinItemList[2]) c('请选择'); else c()} }]" :label-width="0">
                            <button
                                :style="{ width: '100%', height: '50px', border: '1px solid #eee', cursor: !(!form.templateChannel && form.templateChannel != 0) ? 'pointer' : '' }"
                                :disabled="!form.templateChannel && form.templateChannel != 0" @click="(e) => {
                                    e.preventDefault()
                                    handleOpenModal1(form.coinItemList[2],2)
                                }">{{
                                    form.coinItemList[2]?form.coinItemList[2].goodsName : '请选择付费项3'
                                }}</button>
                        </FormItem>

                        </Col>
                        <Col :span="12">
                        <FormItem prop="coinItemList[3]" :rules="[{ required: true,  validator:(rule,value,c)=>{if(!form.coinItemList[3]) c('请选择'); else c()} }]" :label-width="0">
                            <button
                                :style="{ width: '100%', height: '50px', border: '1px solid #eee', cursor: !(!form.templateChannel && form.templateChannel != 0) ? 'pointer' : '' }"
                                :disabled="!form.templateChannel && form.templateChannel != 0" @click="(e) => {
                                    e.preventDefault()                                
                                    handleOpenModal1(form.coinItemList[3],3)
                                }">{{
                                    form.coinItemList[3]?form.coinItemList[3].goodsName : '请选择付费项4'
                                }}</button>
                        </FormItem>

                        </Col>
                        <Col :span="12">
                        <FormItem prop="coinItemList[4]" :rules="[{ required: true,  validator:(rule,value,c)=>{if(!form.coinItemList[4]) c('请选择'); else c()} }]" :label-width="0">
                            <button
                                :style="{ width: '100%', height: '50px', border: '1px solid #eee', cursor: !(!form.templateChannel && form.templateChannel != 0) ? 'pointer' : '' }"
                                :disabled="!form.templateChannel && form.templateChannel != 0" @click="(e) => {
                                    e.preventDefault()
                                    handleOpenModal1(form.coinItemList[4],4)
                                }">{{
                                    form.coinItemList[4]?form.coinItemList[4].goodsName : '请选择付费项5'
                                }}</button>
                        </FormItem>
                        </Col>
                        <Col :span="12">
                        <FormItem prop="coinItemList[5]" :rules="[{ required: true,  validator:(rule,value,c)=>{if(!form.coinItemList[5]) c('请选择'); else c()} }]" :label-width="0">
                            <button
                                :style="{ width: '100%', height: '50px', border: '1px solid #eee', cursor: !(!form.templateChannel && form.templateChannel != 0) ? 'pointer' : '' }"
                                :disabled="!form.templateChannel && form.templateChannel != 0" @click="(e) => {
                                    e.preventDefault()
                                    handleOpenModal1(form.coinItemList[5],5)
                                }">{{
                                    form.coinItemList[5]?form.coinItemList[5].goodsName : '请选择付费项6'
                                }}</button>
                        </FormItem>
                        </Col>
                        <Col :span="12" v-for="(i, j) in form.coinItemList" :key="j" v-show="j > 5">
                            <FormItem :label-width="0" :prop="`coinItemList[${j}]`" :rules="[{ required: true,  validator:(rule,value,c)=>{if(!form.coinItemList[j]) c('请选择'); else c()} }]">
                                <button
                                :style="{ width: '100%', height: '50px', border: '1px solid #eee',position:'relative', cursor: !(!form.templateChannel && form.templateChannel != 0) ? 'pointer' : '' }"
                                :disabled="!form.templateChannel && form.templateChannel != 0" @click="(e) => {
                                    e.preventDefault()
                                    handleOpenModal1(form.coinItemList[j],j)
                                }">{{
                                    form.coinItemList[j]?form.coinItemList[j].goodsName : `请选择付费项${j+1}`
                                }}
                                <div style="position:absolute;top:-5px;right:5px;display:inline-block;cursor:pointer;z-index:2" @click="(e)=>{
                                    e.preventDefault()
                                    e.stopPropagation()
                                    form.coinItemList.splice(j,1)
                                }">
                                    <Icon type="md-close" />
                                </div>
                                </button>
                            </FormItem>
                        </Col>
                        <Col :span="12">
                            <button
                                :disabled="!form.templateChannel && form.templateChannel != 0"
                                :style="{ width: '100%', height: '50px', border: '1px solid #eee', cursor: 'pointer'  }"
                                v-if="form.coinItemList.length<10" @click="(e) => {
                                    e.preventDefault()
                                    form.coinItemList.push(null)
                                }"><Icon type="md-add"/> 添加金币付费项</button>
                        </Col>
                        
                    </Row>
                    </Col>
                </Row>

            </Form>
            <template #footer>
                <Button @click="editVisible = false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
            </template>
        </Modal>
        <Modal v-model="editVisible1" title="编辑付费项">
            <Form @submit.native.prevent v-if="editVisible1" :model="goodsForm">
                <FormItem label="付费项：" prop="newGoodId">
                    <Select v-model="goodsForm.newGoodId" @on-change="goodsForm.goodsReward = 0">
                        <Option v-for="(item, index) in ([goodsGoldList,goodsVipList,goodsPassList][goodsForm.goodType])"
                            :key="index" :value="item.id"
                            :disabled="form.allList ? form.allList.includes(item.id) : false">{{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{ item.goodsNum }}({{ item.goodsName }})
                        </Option>
                    </Select>
                </FormItem>
                <FormItem v-if="goodsForm.goodType == 0" label="金币：" prop="coin">
                    {{ goodsForm.coin }}
                </FormItem>
                <FormItem v-if="goodsForm.goodType == 0" label="赠送金币：" prop="goodsReward">
                    <InputNumber v-model="goodsForm.goodsReward" :min="0" :max="goodsForm.coin||0" />
                </FormItem>
            </Form>
            <template #footer>
                <Button @click="editVisible1 = false">取消</Button>
                <Button type="primary" @click="handleSubmitGoods()">提交</Button>
            </template>
        </Modal>
        <Modal v-model="editVisible2" title="编辑付费项">
            <Form @submit.native.prevent v-if="editVisible2" :model="goodsForm">
                <FormItem label="付费项：" prop="newGoodId">
                    <Select v-model="goodsForm.newGoodId" 
                    @on-change="(e)=>{
                        const goods = goodsGoldList.find(i=>i.id==e)
                        if(goods){
                            goodsForm = {
                                ...goodsForm,
                                coin: goods.goodsNum,
                                reward: goods.goodsReward,
                                goodsName: goods.goodsName
                            }
                        }
                    }">
                        <Option v-for="(item, index) in goodsGoldList"
                            :key="index" :value="item.id"
                            :disabled="form.coinItemList ? form.coinItemList.findIndex(i=>(i&&i.coinId)==item.id)>-1 : false">
                                {{ item.goodsChannelName }}-{{ item.goodsPrice }}-{{ item.goodsNum }}({{ item.goodsName }})
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="金币：">
                    {{ goodsForm.coin }}
                </FormItem>
                <FormItem label="赠送金币：" prop="reward">
                    <InputNumber v-model="goodsForm.reward" :min="0" :max="goodsForm.coin||0" />
                </FormItem>
            </Form>
            <template #footer>
                <Button @click="editVisible2 = false">取消</Button>
                <Button type="primary" @click="handleChangeGoods()">提交</Button>
            </template>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getTempInfo, addTemp, delTemp, getTempList, editTemp, changeStatus, editTempGoods, check } from '@/api/landing'
import { getGoodsList } from '@/api/goods'
import { InputNumber } from 'view-design'
export default {
    components: {
        Pages
    },
    data() {
        return {
            editVisible: false,
            editVisible1: false,
            editVisible2: false,
            data: [],
            submitLoading: false,
            goodsForm: {},
            searchForm: {

            },
            form: {
                coinItemList: [null,null,null,null,null,null],
                vipIdList: [null],
                passIdList: [null]
            },
            loading: false,
            goodsGoldList: [],
            goodsVipList: [],
            goodsPassList: [],
            page: {
                current: 1,
                size: 3,
                total: 0
            }
        }
    },
    methods: {
        handleGetData(current) {
            if (current) this.page.current = current
            else this.page.current = 1
            this.loading = true
            getTempList({
                ...this.page,
                ...this.searchForm
            }).then(({ data }) => {

                this.data = data.records
                this.page.current = data.current
                this.page.total = data.total
                this.loading = true
            })
        },
        async handleOpenEditModal(row) {
            if (row) {
                const r = await getTempInfo(row.id)
                this.form = r.data
                this.hanldeGetGoods()
            } else {
                this.form = {
                    coinItemList: [null,null,null,null,null,null],
                    vipIdList: [null],
                    passIdList: [null],
                    status: false,
                }
            }
            this.editVisible = true
        },
        handleOpenModal(row, item) {
            this.goodsForm = {}

            // this.form = row
            // this.form.templateChannel = row.goodChannel
            // this.form.id = item.id
            this.form = {
                ...item,
                allList: item.allList.map(i => i.goodId)
            }
            this.hanldeGetGoods()
            this.goodsForm.goodChannel = row.goodChannel
            this.goodsForm.oldGoodId = row.goodId
            this.goodsForm.newGoodId = row.goodId
            this.goodsForm.goodType = row.goodType
            this.goodsForm.goodsReward = row.goodReward||0
            this.goodsForm.coin = row.goodNum||0
            console.log(this.goodsForm);
            
            this.editVisible1 = true
        },
        handleOpenModal1(row,index){
            this.goodsForm = {
                goodsIndex: index,
                reward: 0
            }

            if(row){
                this.goodsForm.newGoodId = row.coinId
                this.goodsForm.coin = row.coin||0
                this.goodsForm.reward = row.reward||0
                this.goodsForm.goodsName = row.goodsName
            }
            this.editVisible2 = true
        },
        handleChangeGoods(){
            if(!this.goodsForm.newGoodId) {
                this.$Message.error('请选择付费项')
                return
            }
            if(this.goodsForm.reward > this.goodsForm.coin){
                this.$Message.error('赠送金币数应小于充值金币')
                return
            }
            this.form.coinItemList[this.goodsForm.goodsIndex] = {
                coinId: this.goodsForm.newGoodId,
                coin: this.goodsForm.coin,
                reward: this.goodsForm.reward,
                goodsName: this.goodsForm.goodsName
            }
            this.$refs.formRef.validateField(`coinItemList[${this.goodsForm.goodsIndex}]`)
            this.editVisible2 = false
        },
        handleReachBottom() {
            this.page.current++
            this.handleGetData(this.page.current)
        },
        handleSubmitGoods() {
            editTempGoods({
                ...this.goodsForm,
                templateId: this.form.id
            }).then(r => {
                this.$Message.success('操作成功')
                this.handleGetData()
                this.editVisible1 = false
            })
        },
        handleSubmit() {
            console.log(this.form);
            
            this.$refs.formRef.validate(r => {
                console.log(r);
                
                if (r) {
                    this.submitLoading = true
                    if (this.form.id)
                        check({
                            channel: this.form.templateChannel,
                            status: this.form.status,
                            templateId: this.form.id
                        }).then(r => {
                            if (r.data.isWindow) {
                                this.$Modal.confirm({
                                    title: '提示',
                                    render: () => {
                                        return <div style="max-height:400px;overflow-x:auto">
                                            该付费已被落地页:{r.data.list.map(i => i.placementName).join(',')}使用,继续执行该操作吗？
                                        </div>
                                    },
                                    onOk: () => {
                                        editTemp({
                                            ...this.form,
                                            vipIdList: this.form.vipIdList.filter(i => !!i)
                                        }).then(r => {
                                            if (r.data == true) {
                                                this.$Notice.warning({
                                                    title: '提示',
                                                    desc: '同档位模板已开启，无法开启该模板',
                                                    duration: 0
                                                })
                                            }
                                            this.$Message.success('操作成功')
                                            this.handleGetData()
                                            this.submitLoading = false
                                            this.editVisible = false
                                        }).catch(() => {
                                            this.submitLoading = false
                                        })
                                    },
                                    onCancel: () => {
                                        this.submitLoading = false
                                    }
                                })
                            } else {
                                editTemp({
                                    ...this.form,
                                    vipIdList: this.form.vipIdList.filter(i => !!i)
                                }).then(r => {
                                    if (r.data == true) {
                                        this.$Notice.warning({
                                            title: '提示',
                                            desc: '同档位模板已开启，无法开启该模板',
                                            duration: 0
                                        })
                                    }
                                    this.$Message.success('操作成功')
                                    this.handleGetData()
                                    this.submitLoading = false
                                    this.editVisible = false
                                }).catch(() => {
                                    this.submitLoading = false
                                })
                            }
                        })
                    else addTemp({
                        ...this.form,
                        vipIdList: this.form.vipIdList.filter(i => !!i)
                    }).then(r => {
                        if (r.data == true) {
                            this.$Notice.warning({
                                title: '提示',
                                desc: '同档位模板已开启，无法开启该模板',
                                duration: 0
                            })
                        }
                        this.$Message.success('操作成功')
                        this.handleGetData()
                        this.submitLoading = false
                        this.editVisible = false
                    }).catch(() => {
                        this.submitLoading = false
                    })

                }
            })
        },
        handleChangeStatus(row) {
            check({
                channel: row.templateChannel,
                status: !row.status,
                templateId: row.id
            }).then(r => {
                if (r.data.isWindow) {
                    this.$Modal.confirm({
                        title: '提示',
                        render: () => {
                            return <div style="max-height:400px;overflow-x:auto">
                                该付费已被落地页:{r.data.list.map(i => i.placementName).join(',')}使用,继续执行该操作吗？
                            </div>
                        },
                        onOk: () => {
                            changeStatus(row.id).then(r => {

                                if (r.data == true) {
                                    this.$Notice.warning({
                                        title: '提示',
                                        desc: '同档位模板已开启，无法开启该模板',
                                        duration: 0
                                    })
                                }
                                this.$Message.success('操作成功')
                                this.handleGetData(this.page.current)
                            }).catch(e => {
                                this.$Message.error('操作失败')
                            })
                        }
                    })
                } else {
                    changeStatus(row.id).then(r => {
                        if (r.data == true) {
                            this.$Notice.warning({
                                title: '提示',
                                desc: '同档位模板已开启，无法开启该模板',
                                duration: 0
                            })
                        }
                        this.$Message.success('操作成功')
                        this.handleGetData(this.page.current)
                    }).catch(e => {
                        this.$Message.error('操作失败')
                    })
                }
            })
            return new Promise(() => { })
        },
        handleDel(row) {
            if (!!row.status) {
                this.$Message.error('该模板已启用,请调整后再操作')
                return
            }
            check({
                channel: row.templateChannel,
                status: row.status,
                templateId: row.id
            }).then(r => {
                if (r.data.isWindow) {
                    this.$Modal.confirm({
                        title: '提示',
                        render: () => {
                            return <div style="max-height:400px;overflow-x:auto">
                                该付费已被落地页:{r.data.list.map(i => i.placementName).join(',')}使用,继续执行该操作吗？
                            </div>
                        },
                        onOk: () => {
                            delTemp(row.id).then(r => {
                                this.$Message.success('操作成功')
                                this.handleGetData()
                            })
                        }
                    })
                } else {
                    delTemp(row.id).then(r => {
                        this.$Message.success('操作成功')
                        this.handleGetData()
                    })
                }
            })

        },
        hanldeGetGoods() {
            getGoodsList({ current: -1, size: -1, goodsType: 0, goodsChannel: this.form.templateChannel }).then(r => {
                this.goodsGoldList = r.data.records
            })
            getGoodsList({ current: -1, size: -1, goodsType: 1, goodsChannel: this.form.templateChannel }).then(r => {
                this.goodsVipList = r.data.records
            })
            getGoodsList({ current: -1, size: -1, goodsType: 2, goodsChannel: this.form.templateChannel }).then(r => {
                this.goodsPassList = r.data.records
            })
        }
    },
    mounted() {
        // this.hanldeGetGoods()
        this.handleGetData()
    }

}
</script>

<style lang="less" scoped>
.card-body {
    display: flex;
    flex-wrap: wrap;
    margin: -10px -10px 10px;

    &>div {
        padding: 10px;
        flex: 0 50%;

        &>div {
            height: 80px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #eee;
            border-radius: 8px;
        }
    }
}
.vip{
    :deep(.ivu-select-selected-value){
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    :deep(.ivu-select-placeholder){
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    :deep(.ivu-select-selection){
        height: 50px;
    }
}
</style>